const elements = document.getElementsByClassName('anim');

const inView = () => {
  const windowHeight = window.innerHeight;
  const scrollY = window.scrollY || window.pageYOffset;
  const scrollPosition = scrollY + windowHeight;

  for (let i = 0, l = elements.length; i < l; i++) {
    const elementPosition = elements[i].getBoundingClientRect().top + scrollY + 100;

    if (scrollPosition > elementPosition) {
      if (elements[i].classList.contains('h2')) {
        if ((i % 2) !== 0) {
          elements[i].classList.add('scroll-anim-slide-left');
        } else {
          elements[i].classList.add('scroll-anim-slide-right');
        }
      }

      if (elements[i].classList.contains('caption') ||
        elements[i].classList.contains('fade-in-img') ||
        elements[i].classList.contains('p')
      ) {
        elements[i].classList.add('scroll-anim-fade-in');
      }

      if (elements[i].classList.contains('h3')) {
        elements[i].classList.add('scroll-anim-blur');
      }

      if (elements[i].classList.contains('anim-wide')) {
        elements[i].classList.add('scroll-anim-wide');
      }
    }
  }
};

document.addEventListener('scroll', inView, false);
document.addEventListener('DOMContentLoaded', inView, false);

const windowHeight = window.innerHeight;
const contents = document.getElementsByClassName('fix-bg');

const scrollVal = () => {
  for (let i = 0, l = contents.length; i < l; i++) {
    const style = window.getComputedStyle(contents[i]);
    const styleBackgroundPositionY = style.backgroundPositionY;

    const getPageYOffset = () => {
      if (windowHeight - 100 > contents[i].getBoundingClientRect().y) {
        contents[i].style.backgroundPositionY = 'calc(100% - ' + (contents[i].clientHeight - (windowHeight - contents[i].getBoundingClientRect().y + -100)) + 'px)';
      }
    };

    window.addEventListener('scroll', getPageYOffset, false);
  }
};

scrollVal();
